import React, { useState } from "react";
import Marquee from "react-fast-marquee";
import "../Css/skillsMarquee.css";

// Simple Icons (cdn.simpleicons.org, always "latest") covers most brands
// via a plain slug. OpenAI pulled their mark from the live package at
// OpenAI's request, so "openai"/"chatgpt" 404 there — but npm/jsdelivr
// version URLs are immutable, so the icon is still fetchable from a pinned
// older published version of the same MIT-licensed package. Lovable has no
// icon in Simple Icons at all (confirmed against the CDN directly), so its
// mark is pulled straight from their own site's favicon instead — a
// first-party source rather than a third-party scrape. Either of these,
// like any icon here, silently falls back to the monogram badge (see
// SkillIcon) if the URL ever stops resolving.
const OPENAI_ICON_URL =
  "https://cdn.jsdelivr.net/npm/simple-icons@11/icons/openai.svg";
const LOVABLE_ICON_URL = "https://lovable.dev/favicon.svg";

const SKILLS = [
  { name: "UX Design" },
  { name: "UI Design" },
  { name: "Product Design" },
  { name: "Design Systems" },
  { name: "User Research" },
  { name: "Prototyping" },
  { name: "Figma", iconUrl: "https://cdn.simpleicons.org/figma" },
  { name: "Framer", iconUrl: "https://cdn.simpleicons.org/framer" },
  { name: "Claude", iconUrl: "https://cdn.simpleicons.org/claude" },
  { name: "ChatGPT", iconUrl: OPENAI_ICON_URL },
  { name: "Cursor", iconUrl: "https://cdn.simpleicons.org/cursor" },
  { name: "Lovable", iconUrl: LOVABLE_ICON_URL },
  { name: "AI-Assisted Design" },
  { name: "React JS", iconUrl: "https://cdn.simpleicons.org/react" },
  { name: "JavaScript", iconUrl: "https://cdn.simpleicons.org/javascript" },
  { name: "HTML/CSS", iconUrl: "https://cdn.simpleicons.org/html5" },
];

function SkillIcon({ name, iconUrl }) {
  const [failed, setFailed] = useState(!iconUrl);

  if (failed) {
    return (
      <span className="skill-icon skill-icon-fallback" aria-hidden="true">
        {name.charAt(0)}
      </span>
    );
  }

  return (
    <span className="skill-icon">
      <img src={iconUrl} alt="" onError={() => setFailed(true)} />
    </span>
  );
}

function SkillItem({ name, iconUrl }) {
  return (
    <span className="skill-item">
      <SkillIcon name={name} iconUrl={iconUrl} />
      <span className="skill-name">{name}</span>
    </span>
  );
}

export default function SkillsMarquee() {
  return (
    <section className="skills-marquee-section">
     
      <Marquee speed={40} pauseOnHover gradient={false}>
        {SKILLS.map((skill) => (
          <SkillItem key={skill.name} {...skill} />
        ))}
      </Marquee>
    </section>
  );
}
